import React from 'react';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';

import css from 'styles/components/common/sponsoredBanner.scss';

const SponsoredBanner = ({ newCard = false }) => {
  const { testId, marketplace: { shortName } } = useMartyContext();
  return (
    <div className={cn(css.sponsoredBanner, { [css.newCard]: newCard })} data-test-id={testId('sponsoredBanner')}>
      Sponsored
      <Tooltip
        content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
        wrapperClassName={css.sponsoredTooltipWrapper}
        tooltipClassName={css.sponsoredTooltip}
        direction="down"
        sponsored={true}
        tooltipId="sponsoredProducts">
        <MoreInfo />
      </Tooltip>
    </div>
  );
};

export default SponsoredBanner;
